<template>
    <v-container class="h-100">
        <v-row class="h-100">
            <!--Блок списка чатов -->
            <v-col cols="4" class="blockColumn">
                <v-card class="h-100 elevation-0 blockColumn_card" style="margin-right: 20px">
                    <v-card-title class="p-0 flex-column m-0" style="height: 142px">
                        <v-row class="p-0 m-0 w-100" style="border-bottom: 1px solid #D3DAE1;">
                            <v-col>
                                <v-btn-toggle
                                        class="w-100 group-toggle"
                                        id="toggle-container"
                                        v-model="activeTab"
                                        dense
                                        tile
                                        group
                                >
                                    <v-btn class="order-type-btn" :value="0">
                                        Новые
                                    </v-btn>

                                    <v-btn class="order-type-btn" :value="1">
                                        Мои
                                    </v-btn>

                                    <v-btn class="order-type-btn" :value="2">
                                        Архив
                                    </v-btn>
                                </v-btn-toggle>
                            </v-col>
                        </v-row>
                        <v-row class="w-100">
                            <v-col>
                                <v-text-field
                                        v-model="search"
                                        solo
                                        mandatory
                                        hide-details
                                        placeholder="Поиск по заказам и сообщениям"
                                        prepend-inner-icon="search"
                                />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="p-0 m-0" style="height: calc(100% - 145px)">
                        <ordersList :items="chatItems" @selectionChange="selectChat"></ordersList>
                    </v-card-text>
                </v-card>

            </v-col>
            <!--Блок сообщений -->
            <v-col cols="5" class="blockColumn">
                <orderContent class="elevation-0 blockColumn_card" :selectedChat="selectedChat"
                              @accept="acceptChat"></orderContent>
            </v-col>
            <!--Блок информации-->
            <v-col v-if="selectedChat!=null" cols="3" class="blockColumn h-100" style="overflow-y: scroll">
                <v-card class="elevation-0 blockColumn_card" style="margin-left: 20px">
                    <v-card-title class="m-0 p-0" style="height: 70px">
                        <v-container fluid class="py-0 pl-4 pr-2">
                            <v-row no-gutters>
                                <v-col>
                                    <div class="request-number">Заявка № {{selectedChat.requestNumber}}</div>
                                    <div class="request-date">от
                                        {{formatTimeDateMounthName(selectedChat.requesteDateTime)}}
                                    </div>
                                </v-col>
                                <v-col cols="auto">
                                    <v-menu
                                            v-if="activeTab==1&&selectedChat!=null"
                                            offset-y
                                            bottom
                                            left
                                            :nudge-width="140"
                                            v-model="showActions"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                    icon
                                                    v-on="on"
                                            >
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list dense>
                                            <v-list-item class="mt-2" @click="compliteOrder">
                                                <v-list-item-icon style="margin-right: 18px">
                                                    <v-icon size="22" color="#C4C4C4">mdi-checkbox-marked-circle-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title class="sub-menu-actions">Завершить заказ</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>

                            <div class="my-2">
                                <div class="label-request-details">Клиент</div>
                                <span class="text-request-details">{{selectedChat.clientName}}</span>
                            </div>

                            <div class="my-2">
                                <div class="label-request-details">Транспортное средство</div>
                                <span class="text-request-details">{{selectedChat.carMarkName+' '+selectedChat.carModelName +', '+ selectedChat.carYear}}</span>
                            </div>

                            <orderInfo :code="selectedChat!=null?selectedChat.requestCategoryCode:null"
                                       :requestId="selectedChat!=null?selectedChat.requestId:null"></orderInfo>

                    </v-card-text>
                </v-card>
                <v-card class="elevation-0 blockColumn_card" style="margin-left: 20px; margin-top:20px;">
                    <v-card-title  class="m-0 p-0" style="height: 70px">
                        <v-container fluid class="py-0 pl-4 pr-2">
                            <v-row no-gutters>
                                <v-col>
                                    <div class="request-number">Ответ</div>
                                    <div class="request-date">
                                        {{formatTimeDateMounthName(selectedChat.requesteDateTime)}}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text >
                        <div class="my-2">
                            <div class="label-request-details">Текст</div>
                            <span class="text-request-details">{{selectedChat.answerText}}</span>
                        </div>
                        <div class="my-2">
                            <div class="label-request-details">Оценочная стоимость</div>
                            <span class="text-request-details">От {{selectedChat.priceFrom+'р до '+
                                    selectedChat.priceTo}}р</span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <b-modal v-model="deleteModal" centered>
            <template v-slot:modal-header="{ close }">
                <span style="font-weight: bold;color: #1A2A3A;">Удаление заказа № {{selectedChat.requestNumber}}</span>
            </template>
            <b-container fluid class="text-center">
                <span style="font-weight: 500;color: #1A2A3A;">Вы действительно хотите удалить данный заказ?</span>
            </b-container>
            <template v-slot:modal-footer="{ cancel }">
                <b-row no-gutters align-v="end" class="w-100">
                    <b-col cols="2" offset="8">
                        <b-button
                                variant="primary"
                                size="sm"
                                @click="deleteChat"
                        >Удалить
                        </b-button>
                    </b-col>
                    <b-col cols="1">
                        <b-button
                                variant="outline-secondary"
                                size="sm"
                                @click="deleteModal=false"
                        >Отмена
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </v-container>

</template>

<script>
    import {mapGetters} from 'vuex';
    import iconItem from '../components/icons.vue'
    import orderInfo from '../components/Orders/OrderInfo.vue'

    import ordersList from '../components/Orders/OrdersList.vue'
    import orderContent from '../components/Orders/OrderContent.vue'

    export default {
        name: "Orders",
        components: {iconItem, ordersList, orderInfo, orderContent},
        data() {
            return {
                showActions:false,
                activeTab: 0,
                showInfo: false,
                deleteModal: false,
                search: "",
                timerId: null,
                selectedChat: null,
            }
        },
        mounted() {
            this.$root.connection.on("SendMessageToUser", param => {
                if (this.selectedChat == null || param.chatId != this.selectedChat.chatId) {
                    var chatInfo = this.getChatUser(param.chatId)
                    if (chatInfo != null) {
                        this.$bvToast.toast(param.message, {
                            title: `Сообщение от ${chatInfo.clientName}`,
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 5000,
                            variant:"info",
                            appendToast: true,
                            solid: true
                        })
                    }
                }
                else {
                    //если пришло сообщение в текущий чат, то обновляем интерфейс
                    var curChat = this.selectedChat;
                    this.selectedChat = null;
                    this.selectedChat = curChat;
                }

            })
            //обнуляем количество уведомлений
            this.$store.dispatch("Notifications/removeNotification", 1)
        },

        beforeMount() {
            this.activeTab = 0
            this.getNewOrders()
        },

        computed: {
            ...mapGetters({
                getChatUser: "Chats/getChatUser"
            }),

            chatItems() {
                return this.$store.state.Chats.chats.filter((elem) => {
                    return new RegExp(this.search, 'ig').test(elem.clientName);
                }).sort((a, b) => {
                    if (a.lastMessageDateTime > b.lastMessageDateTime) return -1
                    if (a.lastMessageDateTime < b.lastMessageDateTime) return 1
                    if (a.lastMessageDateTime == b.lastMessageDateTime) return 0
                });
            },

        },
        methods: {
            loadData(tab){
                this.selectedChat = null
                this.$store.dispatch("Chats/reset")
                //подгружаем нужные чаты
                switch (tab) {
                    case 0: {
                        this.getNewOrders()
                        break;
                    }
                    case 1: {
                        this.getActiveOrders()
                        break;
                    }
                    case 2: {
                        this.getHistoryOrders()
                        break;
                    }
                }
            },
            getNewOrders() {
                this.$store.dispatch("Chats/getNewChats").catch(err => {
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка чатов!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            getActiveOrders() {
                this.$store.dispatch("Chats/getActiveChats").catch(err => {
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка чатов!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            getHistoryOrders() {
                this.$store.dispatch("Chats/getHistoryChats").catch(err => {
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка чатов!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            selectChat(item) {
                this.selectedChat = item;
            },

            //удаление текущего чата
            deleteChat() {
                if (this.selectedChat != null) {
                    let model = {
                        requestId: this.selectedChat.chatId.requestId,
                        chatId: this.selectedChat.chatId
                    }
                    this.$store.dispatch("Chats/archive", model).then(() => {
                        this.deleteModal = false
                        this.$bvToast.toast(`Заказ успешно перемещен в архив`, {
                            variant: "success",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    }).catch(err => {
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка удаления чата!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    })
                }

            },

            acceptChat(chatId) {
                this.$store.dispatch("Chats/acceptChat", chatId).then(()=>{
                    this.activeTab = 1
                })
            },
            compliteOrder(){
                this.$store.dispatch("Chats/completeChat", this.selectedChat.chatId).then(()=>{
                    this.$bvToast.toast('Заказ перемещен в архив', {
                        title: `Заказ завершен`,
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant:"info",
                        solid: true
                    })
                    this.loadData(this.activeTab)
                })
            },

            isImage(url) {
                var regStr = /\.jpg$/;
                return new RegExp(regStr, 'ig').test(url);
            },
        },
        watch: {
            activeTab(value) {
                this.loadData(value)
            }
        }
    }
</script>

<style scoped>

    #toggle-container.group-toggle > .order-type-btn {
        opacity: 1;
        margin: 0;
        height: 39px;
        padding: 0 30px;
        text-transform: capitalize;
    }

    #toggle-container.group-toggle > .order-type-btn.v-item--active {
        background-color: var(--color-blue) !important;
        border-radius: 4px;
        color: white;
    }

    #toggle-container.group-toggle > .order-type-btn:not(.v-item--active) {
        color: #6E7C8D;
    }

    .order-type-btn {
        width: 30%;
        min-width: 30%;
    }

    .blockColumn {
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .blockColumn_card {
        border: 1px solid #D3DAE1 !important;
        border-radius: 4px !important;
        max-height: 100%;
    }

    .request-number {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: var(--text-color);
    }

    .request-date {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: var(--color-2);
    }

    .label-request-details {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: var(--color-2);
    }

    .text-request-details {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #1A2A3A;
    }

</style>
